import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = 'Convert GPA to French Grading System';
const DESCRIPTION = "Discover how to easily and accurately convert your university GPA to the French grading system. Learn the details of the French university grading system.";
const KEYWORDS = "French university system, convert GPA, French grading system, bachelor's GPA, master's GPA, university GPA, France";
const OG_URL = 'https://do-calculate.com/calculator/en/gradetofrench';
function GradeToFrench() {
  const [originalValue, setOriginalValue] = useState('');
  const [convertedValue, setConvertedValue] = useState('');
  const [conversionType, setConversionType] = useState('grade');
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToFrenchGrade = (gpa) => {
    if (gpa >= 3.7 && gpa <= 4.0) {
      return "16 – 20";
    } else if (gpa >= 3.5 && gpa < 3.7) {
      return "14 – 15.9";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "12 – 13.9";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "10 – 11.9";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "8 – 9.9";
    } else if (gpa >= 1.5 && gpa < 2.0) {
      return "7 – 7.9";
    } else if (gpa >= 1.0 && gpa < 1.5) {
      return "6 – 6.9";
    } else if (gpa >= 0.5 && gpa < 1.0) {
      return "5 – 5.9";
    } else if (gpa >= 0.0 && gpa < 0.5) {
      return "0 – 4.9";
    } else {
      return 'Invalid input';
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === 'grade') {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 5).toFixed(2);
      }
    } else if (conversionType === 'gpa') {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToFrenchGrade(gpa);
      }
    }
    return 'Invalid input';
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue('');
    setConvertedValue('');
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Discover how to <strong>convert your university GPA</strong> (whether it's a percentage or cumulative) to the <strong>French grading system</strong> easily and accurately using our advanced <strong>GPA conversion tool</strong>. This <strong>GPA calculator</strong> is specifically designed to help you <strong>convert GPA to the French system</strong>, providing you with precise results that align with French academic standards. Whether you're a student planning to study in France, applying for international programs, or need to <strong>convert your grades for academic or professional purposes</strong>, our <strong>GPA conversion tool</strong> offers reliable and quick calculations. Understand the intricacies of the <strong>French university grading system</strong> and use our tool to make well-informed decisions about your educational path. This essential <strong>GPA calculator</strong> helps you seamlessly transition to the French academic framework, ensuring you meet all necessary requirements with confidence.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>Convert University GPA to French System</h2>
                </div>
                <hr />
                <div className="form-group">
                  <b><label>GPA Type:</label></b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === 'grade'}
                      onChange={() => handleConversionTypeChange('grade')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gradeConversion" className="form-check-label">Percentage (100)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === 'gpa'}
                      onChange={() => handleConversionTypeChange('gpa')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">Cumulative (4.00)</label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label htmlFor='originalValue'>{conversionType === 'grade' ? 'Percentage GPA:' : 'Cumulative GPA:'}</label></b>
                    <input
                      type="text"
                      value={originalValue}
                      id='originalValue'
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className='form-control'
                      style={{ width: '200px', marginRight: '4px' }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Calculate                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                {showResult && (
                  <div style={{ fontSize: '15px' }} className="bg-light bg-gradient text-dark">
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Result:</strong>
                    </div>
                    <b>
                      {conversionType === 'grade'
                        ? `Percentage GPA in the French system: ${convertedValue}`
                        : `Cumulative GPA in the French system: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>French University Grading System</h2></u>
                  <p>
                    In France, grades are classified on a scale from 0 to 20, where 20 is the best and 0 is the worst. The grades can be divided as follows:
                  </p>
                  <table >
                    <thead>
                      <tr className='bmi-header'>
                        <th>French Grade</th>
                        <th>Equivalent French Terms</th>
                        <th>Equivalent Percentage</th>
                        <th>GPA (4.0 scale)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>16 – 20</td>
                        <td>Excellent</td>
                        <td>80-100%</td>
                        <td>3.7-4.0</td>
                      </tr>
                      <tr>
                        <td>14 – 15.9</td>
                        <td>Very Good</td>
                        <td>70-79%</td>
                        <td>3.5-3.6</td>
                      </tr>
                      <tr>
                        <td>12 – 13.9</td>
                        <td>Good</td>
                        <td>60-69%</td>
                        <td>3.0-3.4</td>
                      </tr>
                      <tr>
                        <td>10 – 11.9</td>
                        <td>Pass</td>
                        <td>50-59%</td>
                        <td>2.5-2.9</td>
                      </tr>
                      <tr>
                        <td>0 – 9.9</td>
                        <td>Fail</td>
                        <td>0-49%</td>
                        <td>0-2.4</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    This information helps in understanding how to convert grades to the French system and knowing their equivalents in English and percentage terms.
                  </p>
                  <b className='text-primary'>
                    <span>Example: </span>
                    If you have a GPA of 3.0 on a 4.0 scale, you can convert it to the French system using the tool above, and you will get the equivalent result.
                  </b>
                  <p>
                    This tool is very useful for international students who wish to pursue their studies in France or apply for jobs that require a specific academic GPA.
                  </p>
                  <div>
                    <p>
                      France is one of the scientifically advanced countries, and it has many prestigious universities that attract students from all over the world.
                    </p>
                    <p className='alert alert-info'>
                      France has many globally ranked universities, and the academic system in French universities is known for its scientific rigor and modern curricula. Tuition fees in France are reasonable compared to other European countries and the United States.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToFrench;
